var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("You need to login to use this website")]),_c('b-button',{staticClass:"btn loginBtn",attrs:{"variant":"primary","href":_vm.loginURL}},[_vm._v(" Login ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }